/*
 * module.js - The description of the module.
 */

Fundu.Components.Table = (function($) {
    // State
    ///////////////////////////
    var _isInitialized = false;
    var _transactions = false;
    var _investments = false;
    var _useProfile = false;

    var _tableElements = false;
    var _visibleRows = false;

    var _defaultOptions = {
        "serverSide": false,
        "fixedHeader": true,
        "dom": "<'row'<'col-sm-12'fl>>" +
             "<'row'<'col-sm-12'tr>>" +
             "<'row'<'col-sm-6'B><'col-sm-6'ip>>",
        "buttons": [
            {
                "extend": 'colvis',
                "text": Msg("common.actions.show") + " " + Msg('common.term.column')
            },
            {
                "extend": 'copy',
                "text": Msg("common.actions.copy")
            },
            {
                "extend": 'print',
                "text": Msg("common.actions.print")

            },
            'csv', 'excel',
            {
                "extend": 'pdfHtml5',
                "text": Msg("common.file.pdf"),
                "customize": customizePDF
            }
        ],
        "language": {
            "decimal":        "",
            "emptyTable":     Msg("common.search.results.empty"),
            "info":           Msg("common.actions.showing") + " _START_ " + Msg("common.term.to") + " _END_ " + Msg("common.term.of") + " _TOTAL_",
            "infoEmpty":      Msg("common.actions.showing") + " 0 " + Msg("common.term.to") + " 0 " + Msg("common.term.of") + " 0",
            "infoFiltered":   "(" + Msg("common.search.results.filtered") + " _MAX_ " + Msg("common.term.data") +  ")",
            "infoPostFix":    "",
            "thousands":      " ",
            "lengthMenu":      Msg("common.actions.show") + " _MENU_",
            "loadingRecords":  Msg("common.state.loading") + "...",
            "processing":      Msg("common.state.processing") + "...",
            "search":          Msg("common.actions.search") + ":",
            "zeroRecords":     Msg("common.search.results.none"),
            "paginate": {
                "first":       Msg("common.order.first"),
                "last":        Msg("common.order.last"),
                "next":        Msg("common.order.next"),
                "previous":    Msg("common.order.previous")
            },
            "aria": {
                "sortAscending":  ": activate to sort column ascending",
                "sortDescending": ": activate to sort column descending"
            },
            buttons: {
                copyTitle: Msg("common.actions.copy") + " " + Msg("common.term.to.clipboard"),
                copyKeys: Msg("instructions.copy"),
                copySuccess: {
                    _: Msg("common.state.copied") + " %d " + Msg("common.term.row.plural"),
                    1: Msg("common.state.copied") + " 1 " + Msg("common.term.row.plural")
                }
            }
        }

    }

    var _investmentsTableOptions = {
        "responsive": {
            "details": {
                type: 'column',
                target: 'tr'
            }
        },
        "columnDefs": [
            {
                "type": 'fundu-status', //fundu-status sorting is defined in front/assets/scripts/plugins/jquery.datatables.fundu.status.js
                "targets": 5 //matches the index of the status column in investments table
            },
            {
                "type": 'fundu-duedate', //fundu-duedate sorting is defined in front/assets/scripts/plugins/jquery.datatables.fundu.duedate.js
                "targets": 6 //matches the index of the duedate column in investments table
            },
            {
                "targets": "show-more",
                "orderable": false
            }
        ],
        "order": [[ 5, "asc" ], [6, "asc"]]
    };

    var _transactionsTableOptions = {
        "responsive": {
            "details": {
                type: 'column',
                target: 'tr.split'
            }
        },
        "columnDefs": [
            {
                "type": 'fundu-currency', //fundu-currency sorting is defined in front/assets/scripts/plugins/jquery.datatables.fundu.currency.js
                "targets": 3 //matches the index of the sum column in transaction table
            }
        ],
        "order": [[ 0, "desc" ]]
    };

    // Properties
    ///////////////////////////


    // Private Methods
    ///////////////////////////

    // Select elements from HTML
    var selectElements = function() {
    }

    // Check that the elements exist and unbind them
    var checkElements = function() {
        return true;
    };

    var lock = function(table) {
        if (_error) return false;

        _lockState = true;
        $(_tableElements[table]).addClass("processing");
    }

    var unlock = function(table) {
        if (_error) return false;

        _lockState = false;
        $(_tableElements[table]).removeClass("processing");
    }

    var formatTransaction = function(data){
        return "transaktion";
    }

    var formatInvestment = function(data){
        return "investment";
    }

    var format = function(type, data){
        if(type === "tranaction")
            return formatTransaction(data);
        else if(type === "investment")
            return formatInvestment(data);
    }

    var showDetails = function(type){
        var tr = $(this).closest('tr');
        var row = dt.row( tr );
        var idx = $.inArray( tr.attr('id'), _visibleRows );

        if ( row.child.isShown() ) {
            tr.removeClass( 'details' );
            row.child.hide();

            // Remove from the 'open' array
            _visibleRows.splice( idx, 1 );
        }
        else {
            tr.addClass( 'details' );
            row.child( format( type, row.data() ) ).show();

            // Add to the 'open' array
            if ( idx === -1 ) {
                _visibleRows.push( tr.attr('id') );
            }
        }
    }

    var drawDetails = function(){
        $.each( detailRows, function ( i, id ) {
            $('#'+id+' tr.details').trigger( 'click' );
        } );
    }

    var customizePDF = function(doc){
        var style = {
            header: {
                fontSize: 14,
                bold: true,
                margin: [0, 0, 0, 15]
            },
            subheader: {
                fontSize: 12,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            tableHeader: {
                bold: true,
                fontSize: 14,
                color: 'black',
                fillColor: '#e7e7e7',
            }
        };
        doc.styles = style;
    }

    var initializeComponents = function(){

        $.fn.dataTable.moment('DD.MM.YYYY');
        _tableElements = {};

        var tables = $('.table').not('.visible-print-block').each(
            function(index){
                var name = $(this).attr('id').replace('-table','');
                _tableElements[name] = this;

                if(name === "transactions"){

                    var options = $.extend(_transactionsTableOptions,_defaultOptions);
                    // Add event listener for opening and closing details

                } else if(name === "investments"){

                    var options = $.extend(_investmentsTableOptions,_defaultOptions);

                }

                $(this).DataTable(options);//.on( 'draw', drawDetails );
                //$(this).on( 'click', 'tr', showDetails.bind(this, "transaction") );
            }
        );

        enableInvestmentsTableFiltering();
    }

    function enableInvestmentsTableFiltering() {
        $("#investments-allocator-option").on('click', renderInvestmentsTable);
                $("#investments-manual-option").on('click', renderInvestmentsTable);
                $("#investments-all-option").on('click', renderInvestmentsTable);

                $.fn.dataTable.ext.search.push(
                    function( settings, data, dataIndex ) {
                        // Datatables does not allow table specific custom filters so selecting the correct table here
                        if ( settings.nTable != document.getElementById('investments-table')) {
                            return true;
                        }

                        switch ($('input[name=investments-selection]:checked').val()) {
                            case 'allocator':
                                return data.some(function(element) { return element === Msg("common.allocated") });
                            case 'manual':
                                return data.some(function(element) { return element === Msg("common.manual") });
                            default:
                                return true;
                        }
                    }
                );
    }

    function renderInvestmentsTable() {
        $('#investments-table').DataTable().draw();
    }

    // Init
    ///////////////////////////
    var initialize = function() {
        if(_isInitialized) return true;

        selectElements();

        var success = checkElements();
        if (success) {
            initializeComponents();
            //makeRequest();
            _isInitialized = true;
            return true;
        }

        return false;
    }



    // Public Methods
    ///////////////////////////
    var start = function(action) {

    }

    // Reveal public methods
    return {
        init: initialize
    }


})(jQuery)
